enum DeliveryStepStatus {
    PENDING = "PENDING",
    RECEIVED = "RECEIVED",
    IN_PROGRESS = "IN_PROGRESS",
    DELIVERED = "DELIVERED"
}

export default DeliveryStepStatus;